import { gql } from "@apollo/client";


export const WORK_SESSIONS_EXPORT_EXCEL = gql`
    mutation WorkSessionsExportExcel($eeID: ID!) {
        workSessionsExportExcel(ee_id: $eeID) {
            label
            message
            file
        }
    }
`;
